export enum ActionComponent {
  EmailForm = "email-form",
  OverlaySignUpButton = "overlay-sign-up-button",
  SignUpButton = "sign-up-button",
  SocialButtons = "social-buttons",
}
